import { User, UserRole } from "@edl-development/edl-common";
import { BaseUserRoleDTO } from "../base/base-user-role-dto.model";

export class UserHelper {



    public static isParaeducator(user: User) {
        return !!user.UserRoles &&
            user.UserRoles.map(userRole => userRole.RoleName).indexOf('Paraeducator') !== -1;
    }

  public static isSupervisorCurriculumInstruction(UserRoles: BaseUserRoleDTO[]) {

      return !!UserRoles &&
          UserRoles.map(userRole => userRole.roleName).indexOf('Sup_Spec_Education') !== -1;
    }
}
